import { render } from "./MessageDisplay.vue?vue&type=template&id=77837d7d&scoped=true"
import script from "./MessageDisplay.vue?vue&type=script&lang=js"
export * from "./MessageDisplay.vue?vue&type=script&lang=js"

import "./MessageDisplay.vue?vue&type=style&index=0&id=77837d7d&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77837d7d"]])

export default __exports__